/**
 * UPLOAD-04: Normalize legacy CMS upload paths to /storage/uploads/*.
 */
export function normalizeLegacyMediaUrl(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }
  const trimmed = url.trim();
  if (!trimmed) {
    return trimmed;
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed.replace(/(\/\/[^/]+)\/uploads\//i, '$1/storage/uploads/');
  }

  if (trimmed.startsWith('/uploads/')) {
    return `/storage${trimmed}`;
  }

  if (trimmed.startsWith('uploads/')) {
    return `/storage/${trimmed}`;
  }

  return trimmed;
}
